








import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator'
import COdds from '@/components/COdds/COdds.vue'
import COdd from '@/components/COdds/COdd.vue'
import { EventTypes } from '@altenar/models'
const componentName: string = 'CMarket'

@Component({
  name: `${componentName}`,
  components: { COdd, COdds }
})
export default class UiComponent extends Mixins() {
  @Prop({
    default: () => {
      return { Odds: [] }
    }
  })
  public market!: EventTypes.Market
}
Vue.component(componentName, UiComponent)
